import React, { Component } from "react"
import { Container, Col, Row, Table, FormCheck } from 'react-bootstrap'

import { connect } from "react-redux";
import Loading from '../../common/modal/Loading';
import { displayTaxLienDetails, getSearchResultById } from '../../../redux/actions/searchActions'
import SearchPaginator from '../../common/page/SearchPaginator'
import {getPaginatorHelper} from '../../common/page/PaginatorHelper'
import { LOADING_STATUES } from "../../constants/constants";

import CreditCardSearchAuthWindow from "../../../components/common/form/CreditCardSearchAuthWindow";
import CreditCardPriceListWindow from "../../../components/common/form/CreditCardPriceListWindow";
import CreditCardPriceListReAuthWindow from "../../../components/common/form/CreditCardPriceListReAuthWindow"

import axios from "axios";
import configData from "../../../config/config.json";
import { handleError } from "../../../redux/actions/commonStuff";
import AjaxResult from "../../../utils/AjaxResult";

export const SearchResultsTableComponetName = 'TaxLienSearchResultsTable';

const mapStateToProps = state => {

    return {
        creditCardUser: state.currentUserReducer.paymentMethod === 'CREDIT_CARD' ? true : false,
        bookLabel: state.countyConfigCommonReducer.bookLabel,
        searchResults: state.searchResultsReducer,
        paginationPage: state.searchResultsPaginationReducer,
        tableLoading: state.searchResultsTableLoadingReducer,
        selectedRow:  state.searchResultsTableSelectedRowReducer,
        rewind: state.searchSequenceRewindReducer,
        searchResultsSort: state.searchResultsSortReducer,   
        filterApplied: state.searchResultsFilterAppliedFilter,
        searchResultsFilter: state.searchResultsFilterTaxLiensReducer,
        searchResultsVisited: state.searchResultsVisitedReducer
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        select: (id, sourcedDocKey, callback) => {
            if (id) {
                dispatch(displayTaxLienDetails(id, sourcedDocKey, callback))
            }
        }, // For some reason, id can be null sometimes, so checking to see if id has a value.
        filterResults: (document, sortKey, sortDirection, callback) => dispatch({ type: 'FILTER_TAX_LIEN_ID', document, sortKey, sortDirection }, callback()),
        resetRewindSearch: () =>  dispatch({ type: 'RESET_REWIND_SEARCH_SEQUENCE'})
    }
}

class TaxLienSearchResultsTable extends Component {
    state = {
        selectedDocumentId: null,
        selectedDocumentName: '',
        loadingStatus: '',

        token: null,

        creditCardPriceListWindowShow: false,
        creditCardAuthorizeDotNetWindowShow: false,
        creditCardPriceListReAuthWindowShow: false
    }

    handleCreditCardPriceListClose = () => {
        this.setState(
            {
                creditCardPriceListWindowShow: false
            });
    }

    handleCreditCardPriceListContinue = () => {
        this.setState(
            {
                creditCardPriceListWindowShow: false,
                creditCardAuthorizeDotNetWindowShow: true
            });
    }

    handleCreditCardAuthorizeDotNetWindowClose = () => {
        this.setState(
            {
                creditCardAuthorizeDotNetWindowShow: false
            });
    }
    
    showLoading = () => {
        if (this.state.loadingStatus === '') {
            this.setState({
                loadingStatus: LOADING_STATUES.LOADING
            })
            return true;
        }
        return false;
    }

    hideLoading = (message, status, content) => {
        if (content.paymentNeededAgain === true) {
            this.setState({
                loadingStatus: "",
                submitMessage: "",
                creditCardPriceListReAuthWindowShow: true
            })
        } else if (content.paymentNeeded === true) {
            this.setState({
                loadingStatus: "",
                submitMessage: "",
                creditCardPriceListWindowShow: true
            })
        } else if (status === 'ERROR') {
            this.setState({
                loadingStatus: "",
                submitMessage: ""
            })
        } else {
            this.setState({
                loadingStatus: "",
                submitMessage: message,
                creditCardPriceListWindowShow: false,
                creditCardAuthorizeDotNetWindowShow: false,
                creditCardPriceListReAuthWindowShow: false
            })
        }
    }

    handleAuthorizedSubmit = () => {
        let searchResult = getSearchResultById(this, this.state.selectedDocumentId);

        this.props.select(this.state.selectedDocumentId, searchResult.sourcedDocKey, this.hideLoading);
    }

    handleCreditCardPriceListReAuth = () => {
        this.setState({creditCardAuthorizeDotNetWindowShow:true});
    }
    
    handleCreditCardPriceListReAuthWindowClose = () => {
        this.setState(
            {
                creditCardPriceListReAuthWindowShow: false
            });
    }

    handleKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            const clickedId = event.target.closest("tr").id; // find the closest parent tr
            this.props.resetRewindSearch();
            if (this.showLoading() === true) {
                const selectedDocumentName = event.target.closest("tr").getAttribute("name");
                this.setState({ selectedDocumentId: clickedId, selectedDocumentName });

                let searchResult = getSearchResultById(this, clickedId);

                this.props.select(clickedId, searchResult.sourcedDocKey, this.hideLoading);
            }
        }
    }

    handleRowClick = (event) => {
        const clickedId = event.target.closest("tr").id; // find the closest parent tr
        this.props.resetRewindSearch();
        if (this.showLoading() === true) {
            const selectedDocumentName = event.target.closest("tr").getAttribute("name");
            this.setState({ selectedDocumentId: clickedId, selectedDocumentName });

            let searchResult = getSearchResultById(this, clickedId);

            this.props.select(clickedId, searchResult.sourcedDocKey, this.hideLoading);
        }
    }

    handleCheckFilterLimit = () => {
        if (this.props.searchResultsFilter.totalRecordCount >= 100) {
            this.setState(
            {
                showAlert: true,
                alertMessage: 'You have reached the limit of selecting up to 100 records.'
            });
        }
    }

    handleCheckClick = (event) => {
        const clickedId = event.target.closest("tr").id; // find the closest parent tr
        this.props.searchResults.searchResultList.map((searchResult) => {
            if (searchResult.docId == clickedId) {
                this.props.filterResults(searchResult, this.props.searchResultsSort.sortKey, this.props.searchResultsSort.sortDirection, this.handleCheckFilterLimit);
            }
        });
    }

    handleCheckKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            const clickedId = event.target.closest("tr").id; // find the closest parent tr
            this.props.searchResults.searchResultList.map((searchResult) => {
                if (searchResult.docId == clickedId) {
                    this.props.filterResults(searchResult, this.props.searchResultsSort.sortKey, this.props.searchResultsSort.sortDirection, this.handleCheckFilterLimit);     
                }
            });
        }
    }

    checkSelected = (docId) => {
        
        for (const element of this.props.searchResultsFilter.searchResultList) {
            if (element.docId === docId) {
                return true;
            }
        }
        return false;
    }

    componentDidMount() {
        if (this.props.creditCardUser) {
            axios.post(configData.LANDSHARK_SERVER_URL + "creditcard/authorize", {}, { withCredentials: true })
                .then((response) => {

                    let result = new AjaxResult(response);

                    if (!result.isOk()) {
                        result.handleError();
                    } else {
                        this.setState({ token: result.content().token });
                    }
                }, (error) => {
                    handleError(error, this.props.history);
                })
        }
    }

    render() {
        let loadingLabel = this.props.tableLoading === true ? 'Loading' : "Displaying";
        // apply any inactive filter and text filter
		// let filteredList = this.props.accounts.filter(accountResult => 
        // 	(this.state.includeInactive || accountResult.active) && ( !this.state.filterText || accountResult.name.includes(this.state.filterText)))
        let filteredList = this.props.searchResults.searchResultList;
        const numberOfVisibleRecords = 100;
        let numberOfPages = Math.ceil ( filteredList.length / numberOfVisibleRecords );
		let paginationHelper = getPaginatorHelper(this.props.paginationPage, filteredList, numberOfVisibleRecords);

        let displayResults = paginationHelper.currentPageStartingRecordNumber === paginationHelper.currentPageEndingRecordNumber ? 
                                paginationHelper.currentPageStartingRecordNumber :
                                paginationHelper.currentPageStartingRecordNumber + "-" + paginationHelper.currentPageEndingRecordNumber;

        let truncatedResultWarning = <></>;
        if (filteredList.length >= 1000) {
            truncatedResultWarning = <span className='badge badge-danger'>Results truncated.  If needed, narrow criteria and search again.</span>
        }

        // The authorize.net window in CreditCardSearchAuthWindow needs to re-render every time apparently.  I tried to use the authorize.net token as the component key, but apparently, 
        // the token either is too big or has characteers that didn't work out. Therefore, I'm using a random number to force it re-render each time.
        const creditCardAuthorizeDotNetWindowKey = Math.ceil(Math.random() * 1000000000) + "";

        let  selectedDocumentId = 0;
        if (this.props.rewind === true) {
            selectedDocumentId = this.props.selectedRow;
        } else {
            selectedDocumentId = this.state.selectedDocumentId;
        }

        return (
            <>
                    <Container fluid="true" style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 50}}>
                        <Table responsive striped bordered hover size="sm" style={{ maxHeight: 600, overflowY: 'auto',  display: 'inline-block'}} >
                            <thead style={{ display: 'table', width: '100%',   tableLayout: 'fixed'}}>
                            <tr>
                                <th className="table-td-xs" scope="col" style={{ width: '4%' }} aria-label="Selection"></th>
                                <th className="table-td-xs" scope="col" style={{ width: '30%' }}>Instrument<br />Document #</th>
                                <th className="table-td-xs" scope="col" style={{ width: '16%' }}>Recorded Date<br />Lien Date</th>
                                <th className="table-td-xs" scope="col" style={{ width: '30%' }}>Lien #<br />Taxpayers<br /></th>
                                <th className="table-td-xs" scope="col" style={{ width: '20%' }}>Revisions<br />Releases/Revokes</th>
                            </tr>
                            </thead>
                            <tbody key={this.props.paginationPage} style={{ display: 'table', width: '100%', tableLayout: 'fixed', cursor: "pointer"}} >
                                {
                                    paginationHelper.currentPageRecordList.map((searchResult) => {
                                        const selectedClass = selectedDocumentId == searchResult.docId ? "table-active" : ""; // highlight the selected row

                                        let taxpayersBadge = searchResult.taxpayerSearchResults && searchResult.taxpayerSearchResults.length > 1 ? "more" : "";
                                        let taxpayerDisplayName = searchResult.taxpayerSearchResults && searchResult.taxpayerSearchResults.length > 0 && searchResult.taxpayerSearchResults[0] ? searchResult.taxpayerSearchResults[0].name : '';
                                   
                                        let releasesBadge = searchResult.releaseSearchResults && searchResult.releaseSearchResults.length > 1 ? "more" : "";
                                        let hasReleaseOne = searchResult.releaseSearchResults && searchResult.releaseSearchResults.length > 0 && searchResult.releaseSearchResults[0];
                                       
                                        let releaseReovokeOne = '';
                                        if (hasReleaseOne) {
                                            let releaseOne = '--';
                                            let releaseDocNumber = searchResult.releaseSearchResults[0].releaseDisplayDocNumber;
                                            if (releaseDocNumber && releaseDocNumber !== '') {
                                                releaseOne = releaseDocNumber;
                                            }

                                            let revokeOne = '--';
                                            let revokeDocNumber = searchResult.releaseSearchResults[0].revokeDisplayDocNumber;
                                            if (revokeDocNumber && revokeDocNumber !== '') {
                                                revokeOne = revokeDocNumber;
                                            }

                                            releaseReovokeOne = releaseOne + ' / ' + revokeOne; 
                                        }
                                    
                                        let revisionsBadge = searchResult.revisionSearchResults && searchResult.revisionSearchResults.length > 1 ? "more" : "";
                                        let revisionOne = searchResult.revisionSearchResults && searchResult.revisionSearchResults.length > 0 && searchResult.revisionSearchResults[0]  ? searchResult.revisionSearchResults[0].displayDocNumber : '';

                                        const selected = this.checkSelected(searchResult.docId);

                                        let cursorStyle = {cursor: 'wait' };
                                        if (searchResult.docId) {
                                            cursorStyle = { cursor: 'pointer' }
                                        }

                                        return (
                                            <tr tabIndex={0} className={selectedClass} style={cursorStyle} id={searchResult.docId} name={searchResult.displayDocNumber} onKeyDown={this.handleKeyDown} onClick={this.handleRowClick}>
                                                { 
                                                    selected &&
                                                    <td className="table-td-xs" style={{ width: '4%' }} ><FormCheck onKeyDown={this.handleCheckKeyDown} onChange={this.handleCheckClick} checked={true} aria-label="Uncheck to unselect" disabled={this.props.filterApplied}></FormCheck></td>
                                                }
                                                { 
                                                    !selected &&
                                                    <td className="table-td-xs" style={{ width: '4%' }} ><FormCheck onKeyDown={this.handleCheckKeyDown} onChange={this.handleCheckClick} checked={false} aria-label="Check to select" disabled={this.props.filterApplied}></FormCheck></td>
                                                }
                                                <td className="table-td-xs" style={{ width: '30%' }} ><strong>{searchResult.instrumentDescription}</strong><br />{searchResult.displayDocNumber ? searchResult.displayDocNumber : 'Loading'}<br/></td>
                                                <td className="table-td-xs" style={{ width: '16%' }}>{searchResult.recordedDate}<br/>{searchResult.lienDate}</td>
                                                <td className="table-td-xs" style={{ width: '30%' }}>{searchResult.lienNumber}<br/>{taxpayerDisplayName}&nbsp;<span className='badge badge-light'>{taxpayersBadge}</span></td>
                                                <td className="table-td-xs" style={{ width: '20%' }}>{revisionOne}&nbsp;<span className='badge badge-light'>{revisionsBadge}</span><br/>{releaseReovokeOne}&nbsp;<span className='badge badge-light'>{releasesBadge}</span></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                        <Row>
                            <Col style={{ marginLeft: 4}} >{loadingLabel} Results: {displayResults} of {filteredList.length} {truncatedResultWarning}</Col>
                        </Row>
                        <Row>
                            <Col style={{ marginLeft: 4}} ><SearchPaginator style={{ justifyContent: 'center' }} componentName={SearchResultsTableComponetName} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></SearchPaginator></Col>
                        </Row>
                    </Container>
                 
                <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
                <CreditCardPriceListWindow show={this.state.creditCardPriceListWindowShow} handleContinueClicked={this.handleCreditCardPriceListContinue} handleCloseClicked={this.handleCreditCardPriceListClose} />
                {this.state.creditCardAuthorizeDotNetWindowShow && <CreditCardSearchAuthWindow show={this.state.creditCardAuthorizeDotNetWindowShow} handleAuthorizedSubmit={this.handleAuthorizedSubmit} handleCloseClicked={this.handleCreditCardAuthorizeDotNetWindowClose} token={this.state.token} />}
                <CreditCardPriceListReAuthWindow show={this.state.creditCardPriceListReAuthWindowShow} handleContinueClicked={this.handleCreditCardPriceListReAuth} handleCloseClicked={this.handleCreditCardPriceListReAuthWindowClose} />

            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxLienSearchResultsTable);